/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
export default class AchievementLevel extends Model {
  level() {
    return Model.attribute('level').call(this);
  }
  points() {
    return Model.attribute('points').call(this);
  }
  name() {
    return Model.attribute('name').call(this);
  }
  icon() {
    return Model.attribute('icon').call(this);
  }
  image() {
    return Model.attribute('image').call(this);
  }
  description() {
    return Model.attribute('description').call(this);
  }
  backgroundColor() {
    return Model.attribute('backgroundColor').call(this);
  }
  iconColor() {
    return Model.attribute('iconColor').call(this);
  }
  levelBgColor() {
    return Model.attribute('levelBgColor').call(this);
  }
  levelTextColor() {
    return Model.attribute('levelTextColor').call(this);
  }
  userCount() {
    return Model.attribute('userCount').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt').call(this);
  }
  achievement() {
    return Model.hasOne('achievement').call(this);
  }
  users() {
    return Model.hasMany('users').call(this);
  }
  lastUsers() {
    return Model.hasMany('lastUsers').call(this);
  }
  trigger() {
    return Model.attribute('trigger').call(this);
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/models/AchievementLevel', AchievementLevel);